// extracted by mini-css-extract-plugin
module.exports = {"table":"MinerServerList_table__0Vrei"};